import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss'],
  viewProviders: [
    {
        provide: ControlContainer,
        useExisting: FormGroupDirective
    }    
]
})
export class CustomInputComponent implements OnInit {

  @Input()
  formGroup!: UntypedFormGroup;

  @Input()
  minlength: number = 0;

  @Input()
  help: string = '';

  @Input()
  maxlength: number = 200;

  @Input()
  controlName: string = 'field';

  @Input()
  label: string = 'label';

  @Input()
  type: string = 'text';

  @Input()
  mask: string = '';

  @Input()
  suffix: string = '';

  @Input()
  prefix: string = '';

  @Input()
  dropSpecialCharacters: boolean = false;

  @Input()
  showMaskTyped: boolean = false;

  @Input()
  customPattern: any;

  @Input()
  list!: any[];

  @Input()
  listValue: string = 'value';

  @Input()
  listText: string = 'text';

  @Input()
  disabled: boolean = false;

  @Input()
  selecione: boolean = true;

  @Input()
  autofill: boolean = false;

  @Input()
  inputClass: string = '';

  @Input() 
  inputStyle: { [key: string]: any } = {};

  @Output() 
  modelChangeEvent: EventEmitter<any> = new EventEmitter();

  @Output() 
  enterEvent: EventEmitter<any> = new EventEmitter();

  get classList() {
    return this.inputClass
      .split(' ')
      .concat(this.validaCampo() ? ['is-invalid'] : []);
  }

  constructor() { }

  ngOnInit(): void {
  }

  validaCampo() {
    if (!this.formGroup) return;
    return this.formGroup.controls[this.controlName].touched && !this.formGroup.controls[this.controlName].valid;
  }

  getField() {
    if (!this.formGroup) return;
    return this.formGroup.controls[this.controlName];
  }

  modelChange(item: any){
    this.modelChangeEvent.emit(item);
  }

  valueChange(){
    this.modelChangeEvent.emit(this.getField()?.value);
  }

  clickEnter(){
    this.enterEvent.emit(true);
  }
}
